import { Grid, List } from 'lucide-react';

export type ViewMode = 'grid' | 'list' | 'table';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewModeToggle({ value, onChange }: ViewModeToggleProps) {
  return (
    <div className="flex gap-1 p-1 bg-background-subtle rounded-lg flex-shrink-0">
      <button
        onClick={() => onChange('grid')}
        className={`p-2 rounded transition-colors ${
          value === 'grid'
            ? 'bg-background text-foreground'
            : 'text-foreground-muted hover:text-foreground'
        }`}
        aria-label="Grid view"
      >
        <Grid className="h-5 w-5" />
      </button>
      <button
        onClick={() => onChange('list')}
        className={`p-2 rounded transition-colors ${
          value === 'list'
            ? 'bg-background text-foreground'
            : 'text-foreground-muted hover:text-foreground'
        }`}
        aria-label="List view"
      >
        <List className="h-5 w-5" />
      </button>
    </div>
  );
}
